import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  wrapper: {
    position: 'absolute',
    display: 'block',
    width: '100vw',
    height: '100vh'
  },
  message: {
    textAlign: 'center',
    fontSize: '18px',
    margin: '45vh 1rem 0'
  }
});

class KioskNotFound extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes, theme } = this.props;

    return (
      <div className={classes.wrapper}>
        <p className={classes.message}>
          No kiosk with this URL was found. Please contact your technical team for the correct kiosk URL.
        </p>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(KioskNotFound);
